import { Modal, ModalProps } from "@chakra-ui/react";
import React from "react";
import { useIntercom } from "react-use-intercom";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";

/**
 * Set standard behaviour for all modals.
 *
 * Importantly, all modals responsively resize to be full screen on small
 * mobile viewports.
 */
export function AppModal({ size, ...props }: ModalProps): React.ReactElement {
  const isMobile = useCurrentBreakpoint().isAtMost("xs");

  // Disable the trapFocus feature only when the intercom widget is open.
  // We could just disable trapFocus all the time, but when trapFocus is
  // disabled, it allows the user to navigate and interact outside the modal
  // (e.g. using keyboard navigation), which we want to prevent as much as
  // practical.
  const { isOpen: isIntercomOpen } = useIntercom();

  return (
    <Modal
      trapFocus={!isIntercomOpen}
      useInert={!isIntercomOpen}
      size={isMobile ? "full" : size}
      scrollBehavior="inside"
      isCentered
      {...props}
    />
  );
}
